import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setQuestionAnswerList } from '../../system/redux/reducers/surveyReducer';

const SurveyTextArea = (props) => {
  const dispatch = useDispatch();
  const [question, setQuestion] = useState(props.question);

  const [answerDescription, setAnswerDescription] = useState('');

  const handleChange = (event) => {
    const newValue = event.target.value;
    setAnswerDescription(newValue);

    const payload = {
      id: question.id, // Assuming this is the question ID
      answerList: [
        {
          questionOptionId: question.optionList[0].id,
          // answerDescription: answerDescription,
          answerDescription: newValue,
        }
      ]
    };
    
    // Log the payload
    console.log(payload);

    dispatch(setQuestionAnswerList(payload));
  };

  return (
    <>
      <input type='hidden' id={"question-id-" + question.id + "-option-id-" + question.optionList[0]?.id} class={"question-id-" + question.id + "-option-id-" + question.optionList[0]?.id} name={"questionList[" + question.questionSequenceNo + "].answerList[0].questionOptionId"} value={question.optionList[0].id} />
      
      <Form.Control as="textarea"
        id={"question-id-" + question.id + "-option-id-" + question.optionList[0].id + "-answerDescription"}
        className={"question-id-" + question.id + "-option-id-" + question.optionList[0].id + "-answerDescription"}
        name={"questionList[" + question.questionSequenceNo + "].answerList[" + question.optionList[0].optionSequenceNo + "].answerDescription"}
        value={answerDescription}
        onChange={handleChange}
        required={question.questionMandatory}
      />
    </>
  );
};

export default SurveyTextArea;
